export default __webpack_public_path__ + "static/media/invitation-up.37ec295a.gif";